// rrtvFormat.js — pure formatters, endpoint constants, tokens, persisted targets.
// No React. Shared by every RRTV module.

export const API_URL   = '/api/go';
export const WS_URL    = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws`;
export const LOGO_HOST = '/api/logos';
export const DINO_URL  = '/api/tickers61';
export const NEWS_URL  = '/api/news82';

// Theme handed to mounted research children (design tokens)
export const CHILD_THEME = {
  background: '#0e0d1f',
  cardBg: 'rgba(18,18,18,0.8)',
  card: 'rgba(18,18,18,0.8)',
  border: 'rgba(255,255,255,0.06)',
  borderStrong: 'rgba(255,255,255,0.12)',
  textPrimary: '#ffffff',
  textSecondary: 'rgba(255,255,255,0.70)',
  text: '#ffffff',
  accent: '#6660fe',
};

export const fmtNum = (n, d = 2) =>
  n == null || isNaN(n)
    ? 'N/A'
    : n.toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtVol = (v) => {
  if (!v) return 'N/A';
  if (v >= 1e9) return `${(v / 1e9).toFixed(1)}B`;
  if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (v >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
  return v.toFixed(0);
};

export const fmtTime = (d) =>
  d ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '--:--:--';

export const baseSymbol = (ticker) => ticker?.split('.')?.[0] ?? '';

export const nowBRT = () => {
  const d = new Date();
  const utc = d.getTime() + d.getTimezoneOffset() * 60000;
  return new Date(utc - 3 * 3600000);
};
export const brtMinutes = () => { const t = nowBRT(); return t.getHours() * 60 + t.getMinutes(); };

export const tzClock = (tz) => {
  try {
    return new Date().toLocaleTimeString('pt-BR', { timeZone: tz, hour: '2-digit', minute: '2-digit' });
  } catch { return '--:--'; }
};

// Currency-aware price formatter (from the Stocks/Asset UX)
export const fmtAssetPrice = (v, ccy) => {
  if (v == null || isNaN(v)) return '—';
  const n = Number(v);
  if (ccy === 'BRL') return `R$ ${fmtNum(n)}`;
  if (ccy === 'USD') return `$ ${fmtNum(n)}`;
  if (ccy === 'EUR') return `€ ${fmtNum(n)}`;
  if (ccy === 'GBP') return `£ ${fmtNum(n)}`;
  if (!ccy) return fmtNum(n);
  const noDec = ['JPY','KRW','IDR','CLP','TWD','VND'].includes(ccy);
  return `${ccy} ${n.toLocaleString('pt-BR', { minimumFractionDigits: noDec ? 0 : 2, maximumFractionDigits: noDec ? 0 : 2 })}`;
};

// Per-ticker price target, persisted (the "set your own price" ask)
export const readTarget  = (t) => { try { const v = localStorage.getItem('rrtv:target:' + t); return v ? Number(v) : null; } catch { return null; } };
export const writeTarget = (t, v) => { try { (v == null || isNaN(v)) ? localStorage.removeItem('rrtv:target:' + t) : localStorage.setItem('rrtv:target:' + t, String(v)); } catch {} };
